import AIchatIntegration2 from './AIchatIntegration2';
import AnalyticsBuilderModule from './AnalyticsBuilderModule';
import AtAGlanceModule from './AtAGlanceModule';
import BannerTemplate from './BannerTemplate';
import BlurredContent from './BlurredContent';
import BrowseByModule from './BrowseByModule';
import CaseStudyModule from './CaseStudyModule';
import ColourLibraryModule from './ColourLibraryModule';
import ColourStrip from './ColourStrip/ColourStrip';
import ColumnLayout from './ColumnLayout';
import ComingSoonModule from './ComingSoonModule';
import EditorsPickModule from './EditorsPickModule';
import EventCalendarModule from './EventCalendarModule';
import ExpertElement from './ExpertElement/ExpertElement';
import ExpertsListingModule from './ExpertsListingModule/ExpertsListingModule';
import FeaturedModule from './FeaturedModule';
import FilterableReportGridModule from './FilterableReportGridModule';
import FullPageSlideModule from './FullPageSlideModule/FullPageSlideModule';
import FutureInsightsModule from './FutureInsightsModule';
import GlobalDataIntegration0 from './GlobalDataIntegration0';
import HeroCarousel from './HeroCarousel';
import HeroModule from './HeroModule/HeroModule';
import HomeHeroModule from './HomeHeroModule';
import ImageCarousel from './ImageCarousel/ImageCarousel';
import ImageFocusWithGalleryModule from './ImageFocusWithGalleryModule';
import ImageLibraryModule from './ImageLibraryModule/ImageLibraryModule';
import ImageSingle from './ImageSingle';
import ImagesRowModule from './ImagesRowModule';
import ImageVideoX2Block from './ImageVideoX2Block';
import InfoBlockModule from './InfoBlockModule/InfoBlockModule';
import InnovationPlatformsModule from './InnovationPlatformsModule';
import InnovationPlatformsNavigation from './InnovationPlatformsNavigation';
import LegacyReportContent from './LegacyReportContent';
import LogoCarousel from './LogoCarousel';
import LookAheadLandingPageModule from './LookAheadLandingPageModule';
import MacroDriversListingModule from './MacroDriversListingModule';
import MediaGalleryImagesList from './MediaGalleryImagesList/MediaGalleryImagesList';
import MultimediaItem from './MultimediaItem';
import MultipleCardContent from './MultipleCardContent';
import MyCSMPage from './MyCSMPage';
import NudgeWindow from './NudgeWindow';
import PermissionsChecker from './PermissionsChecker';
import PersonalisationConfigurationModule from './PersonalisationConfigurationModule';
import PersonalisedReportsModule from './PersonalisedReportsModule';
import PollingModule from './PollingModule';
import ProfileModel from './ProfileModel';
import PullStatModule from './PullStatModule';
import QuoteCarousel from './QuoteCarousel';
import QuoteModule from './QuoteModule';
import RelatedItems from './RelatedItems';
import ReportCarouselModule from './ReportCarouselModule';
import ReportHero from './ReportHero/ReportHero';
import ReportNavigationBar from './ReportNavigationBar';
import ReportsGridModule from './ReportsGridModule';
import ReportsSearchModule from './ReportsSearchModule';
import ReportStub from './ReportStub';
import RichTextModule from './RichTextModule';
import ScrapbookModule from './ScrapbookModule';
import ScriptModule from './ScriptModule';
import SectionElement from './SectionElement';
import SectionHeadingModule from './SectionHeadingModule';
import SideBySideModule from './SideBySideModule/SideBySideModule';
import StatBankModule from './StatBankModule';
import StatsListModule from './StatsListModule';
import StubTopicsList from './StubTopicsList';
import StylusAlertsModule from './StylusAlertsModule';
import SubsCfgWizard from './SubsCfgWizard';
import SummaryListModule from './SummaryListModule';
import TabbedNavigationModule from './TabbedNavigationModule';
import TableauIframeModule from './TableauIframeModule';
import TechLaunchDatabaseEntryModule from './TechLaunchDatabaseEntryModule';
import TechLaunchDatabaseSearchModule from './TechLaunchDatabaseSearchModule/TechLaunchDatabaseSearchModule';
import ThreeCardContent from './ThreeCardContent';
import ThreeColumnListing from './ThreeColumnListing';
import TickerTapeModule from './TickerTapeModule';
import TopicsModule from './TopicsModule';
import TopTenModule from './TopTenModule';
import TrendEvolutionModule from './TrendEvolutionModule';

export const getModule = (name: string) => {
  const modules: { [key: string]: any } = {
    AIchatIntegration2,
    AnalyticsBuilderModule,
    AtAGlanceModule,
    BannerTemplate,
    BlurredContent,
    BrowseByModule,
    CaseStudyModule,
    ColourLibraryModule,
    ColourStrip,
    ColumnLayout,
    ComingSoonModule,

    EditorsPickModule,
    EventCalendarModule,
    ExpertElement,
    ExpertsListingModule,
    FeaturedModule,
    FilterableReportGridModule,
    FullPageSlideModule,
    FutureInsightsModule,
    GlobalDataIntegration0,
    HeroCarousel,
    HeroModule,
    HomeHeroModule,
    ImageCarousel,
    ImageFocusWithGalleryModule,
    ImageLibraryModule,
    ImageSingle,
    ImagesRowModule,
    ImageVideoX2Block,
    InfoBlockModule,
    InnovationPlatformsModule,
    InnovationPlatformsNavigation,
    LegacyReportContent,
    LogoCarousel,
    LookAheadLandingPageModule,
    MacroDriversListingModule,
    MediaGalleryImagesList,
    MultimediaItem,
    MultipleCardContent,
    MyCSMPage,
    NudgeWindow,
    PermissionsChecker,
    PersonalisationConfigurationModule,
    PersonalisedReportsModule,
    PollingModule,
    ProfileModel,
    PullStatModule,
    QuoteCarousel,
    QuoteModule,
    RelatedItems,
    ReportCarouselModule,
    ReportHero,
    ReportNavigationBar,
    ReportsGridModule,
    ReportsSearchModule,
    ReportStub,
    RichTextModule,
    ScrapbookModule,
    ScriptModule,
    SectionElement,
    SectionHeadingModule,
    SideBySideModule,
    StatBankModule,
    StatsListModule,
    StubTopicsList,
    StylusAlertsModule,
    SubsCfgWizard,
    SummaryListModule,
    TabbedNavigationModule,
    TableauIframeModule,
    TechLaunchDatabaseEntryModule,
    TechLaunchDatabaseSearchModule,
    ThreeCardContent,
    ThreeColumnListing,
    TickerTapeModule,
    TopicsModule,
    TopTenModule,
    TrendEvolutionModule,
  };

  return modules[name];
};
